import React, { useMemo, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

import OperatorExportFilters from '../../components/OperatorExport/OperatorExportFilters';
import OperatorExportHeader from '../../components/OperatorExport/OperatorExportHeader';
import OperatorExportTable from '../../components/OperatorExport/OperatorExportTable';

import styles from './OperatorExport.styles';
import PageLoader from '../../../../components/loaders/PageLoader';

import { useOperatorExportSummaries } from '../../hooks/useOperatorExportSummaries';
import { filterOperators, standardDateFormat } from '../../utils/operatorexports.helpers';
import exportToCsv from '../../../../utils/exportToCsv';

export default function OperatorExport() {
  const { isSidebarExpanded } = useOutletContext();

  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({ operator: [], error: [] });

  const currentDate = new Date();

  const { rows, loading, refreshing } = useOperatorExportSummaries(currentDate);

  const filteredRows = useMemo(
    () => filterOperators(rows, filters, searchQuery),
    [rows, filters, searchQuery]
  );

  const operatorOptions = useMemo(() => [...new Set(rows.map((r) => r.operatorCode))], [rows]);

  const handleExport = useCallback(() => {
    const ts = new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '').replace('T', '_');
    const filename = `operator_export_status_${ts}.csv`;
    const rowsToExport = filteredRows.map(({ errorsCount, ...rest }) => rest);

    const d = currentDate;
    const todayDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const oneDayAgoDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const twoDaysAgoDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const threeDaysAgoDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const fourDaysAgoDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const fiveDaysAgoDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const sixDaysAgoDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const sevenDaysAgoDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const eightDaysAgoDate = standardDateFormat(d);

    d.setDate(d.getDate() - 1);
    const nineDaysAgoDate = standardDateFormat(d);

    const headerMap = {
      operatorCode: 'Operator Code',
      nineDaysAgo: nineDaysAgoDate,
      eightDaysAgo: eightDaysAgoDate,
      sevenDaysAgo: sevenDaysAgoDate,
      sixDaysAgo: sixDaysAgoDate,
      fiveDaysAgo: fiveDaysAgoDate,
      fourDaysAgo: fourDaysAgoDate,
      threeDaysAgo: threeDaysAgoDate,
      twoDaysAgo: twoDaysAgoDate,
      oneDayAgo: oneDayAgoDate,
      today: todayDate,
    };
    exportToCsv(filename, rowsToExport, headerMap);
  }, [filteredRows]);

  return (
    <Box
      sx={{
        ...styles.fileContent,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      {loading ? (
        <PageLoader />
      ) : (
        <>
          <OperatorExportHeader
            title="Operator Export Summary"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onSearch={() => {}}
          />
          
          <OperatorExportFilters
            filters={filters}
            setFilters={setFilters}
            operatorOptions={operatorOptions}
            onExport={handleExport}
          />

          <OperatorExportTable rows={filteredRows} refreshing={refreshing} />
        </>
      )}
    </Box>
  );
}
